import script from "./TheNotaioLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNotaioLayout.vue?vue&type=script&setup=true&lang=js"

import "./TheNotaioLayout.vue?vue&type=style&index=0&id=50e1d450&lang=css"

const __exports__ = script;

export default __exports__